import React, { forwardRef, useEffect, useRef, useState } from "react";

import { getSnippetText } from "../../utils/functions";
import { Link } from "react-router-dom";

const MappedText = ({ textData }) => {
  return textData?.map((data) => (
    <span className={data.class} key={data.key}>
      {data.text}
    </span>
  ));
};

const TooltipText = ({ isRightMost, subText, subText2, isLeftMost }) => {
  return (
    <div className="ellipsis-icon">
      {/* <img src={infoIcon} alt="info" /> */}
      <div></div>
      <span
        className={`ellipsis-text ${
          isRightMost ? "changeToolTip" : isLeftMost ? "leftTooltip" : ""
        }`}
      >
        <MappedText textData={subText2} />
      </span>
    </div>
  );
};

const ChildComp = forwardRef(
  ({ snippet, index, cardWidth, currentCardsIndex }, ref) => {
    // const navigate = useNavigate();
    const textRef = useRef(null);

    const [isOverflowing, setIsOverflowing] = useState(false);
    const [text, setText] = useState([]);
    const [subText, setSubText] = useState([]);

    useEffect(() => {
      const data = getSnippetText({
        text: !snippet.isDisplayIrr
          ? snippet?.absolute_return || snippet?.irr
          : snippet?.irr || snippet?.absolute_return,
      });

      if (data && data.length) {
        const subDataText = data?.map((item) => item.text).join(" ");
        setSubText(subDataText);
        setText(data);
      }
    }, [snippet]);

    useEffect(() => {
      if (textRef.current) {
        setTimeout(() => {
          const isTextOverflowing =
            textRef.current.scrollHeight > textRef.current.clientHeight;
          setIsOverflowing(isTextOverflowing);
        }, 100);
      }
    }, [textRef.current]);

    return (
      <div
        className={`embla__slide ${isOverflowing ? "text_hover" : ""}`}
        style={{
          flex: `0 0 ${cardWidth}%`,
        }}
        id={index + 1}
        key={index}
      >
        <Link
          className="slide"
          // onClick={() =>
          //   navigate(snippet.to, {
          //     state: {
          //       from: "home-snippet",
          //       ...snippet,
          //     },
          //   })
          // }
          to={snippet.to}
          state={{
            from: "home-snippet",
            ...snippet,
          }}
        >
          <p className="snippet-title">{snippet.page}</p>
          <p ref={textRef} className="snip-sub-title">
            {text?.map((data) => (
              <span className={data.class} key={data.key}>
                {data.text}
              </span>
            ))}
            {isOverflowing && (
              <TooltipText
                isRightMost={currentCardsIndex === index}
                isLeftMost={currentCardsIndex - 3 === index}
                subText={subText}
                subText2={text}
              />
            )}
          </p>
        </Link>
      </div>
    );
  },
);

const EmblaCarousel = (props, ref) => {
  const { slides, cardWidth, currentCardsIndex } = props;
  const cardsRef = useRef(null);

  return (
    <section className="embla">
      <div className="embla__viewport" ref={ref}>
        <div className="embla__container" ref={cardsRef}>
          {slides.map((snippet, index) => (
            <ChildComp
              snippet={snippet}
              index={index}
              cardWidth={cardWidth}
              ref={cardsRef}
              currentCardsIndex={currentCardsIndex}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default forwardRef(EmblaCarousel);
